export type PaymentMethodType = 'cash-payment' | 'credit-payment';

// Which screen of the pay flow is currently showing
export enum PayStep {
  Method = 'method',
  CreditType = 'creditType',
  CreditDetails = 'creditDetails',
  Otp = 'otp',
}
